import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function VennDiagramIcon(props: IconProps) {
  return (
    <Icon width="207px" height="134px" fill="none" viewBox="0 0 207 134" {...props}>
      <circle cx="67.102" cy="66.846" r="66.667" fill="#E2DCFF" />
      <circle cx="150.436" cy="70.692" r="56.41" fill="#A5F0FC" />
      <Box
        as="path"
        fill="#2E90FA"
        fillRule="evenodd"
        d="M114.201 114.029c12.089-12.068 19.568-28.752 19.568-47.182 0-16.43-5.944-31.472-15.798-43.093-14.818 10.165-24.537 27.222-24.537 46.55 0 17.635 8.092 33.38 20.767 43.725Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
